import { FC, memo } from 'react'
import type { Props } from './types'
import * as S from './styles'

const Loading: FC<Props> = ({ width = '100%', height = 'auto' }) => {
  return (
    <S.Container $height={height} $width={width} data-testid="loading-spinner">
      <S.Spinner>
        <S.SpinnerLine variant={1}>
          <S.SpinnerLineCog>
            <S.SpinnerLineCogInner variant="left" />
          </S.SpinnerLineCog>
          <S.SpinnerLineTicker>
            <S.SpinnerLineCogInner variant="center" />
          </S.SpinnerLineTicker>
          <S.SpinnerLineCog>
            <S.SpinnerLineCogInner variant="right" />
          </S.SpinnerLineCog>
        </S.SpinnerLine>
        <S.SpinnerLine variant={2}>
          <S.SpinnerLineCog>
            <S.SpinnerLineCogInner variant="left" />
          </S.SpinnerLineCog>
          <S.SpinnerLineTicker>
            <S.SpinnerLineCogInner variant="center" />
          </S.SpinnerLineTicker>
          <S.SpinnerLineCog>
            <S.SpinnerLineCogInner variant="right" />
          </S.SpinnerLineCog>
        </S.SpinnerLine>
        <S.SpinnerLine variant={3}>
          <S.SpinnerLineCog>
            <S.SpinnerLineCogInner variant="left" />
          </S.SpinnerLineCog>
          <S.SpinnerLineTicker>
            <S.SpinnerLineCogInner variant="center" />
          </S.SpinnerLineTicker>
          <S.SpinnerLineCog>
            <S.SpinnerLineCogInner variant="right" />
          </S.SpinnerLineCog>
        </S.SpinnerLine>
        <S.SpinnerLine variant={4}>
          <S.SpinnerLineCog>
            <S.SpinnerLineCogInner variant="left" />
          </S.SpinnerLineCog>
          <S.SpinnerLineTicker>
            <S.SpinnerLineCogInner variant="center" />
          </S.SpinnerLineTicker>
          <S.SpinnerLineCog>
            <S.SpinnerLineCogInner variant="right" />
          </S.SpinnerLineCog>
        </S.SpinnerLine>
      </S.Spinner>
    </S.Container>
  )
}

export default memo(Loading)
